import React from "react";
import { DropdownSelector } from "./DropdownSelector";
import { useApplicationContext } from "../context/ApplicationContext";

/**
 * PlatformSelector - Displays and allows switching between different platform environments
 *
 * Platform list is fetched during app initialization (see useAuthentication) and stored
 * in ApplicationContext. This component simply reads the list of platforms and the currently selected platform
 * from context and renders a dropdown menu for the user to select a different platform.
 * Selecting a different platform opens the shared confirm modal rather than switching immediately.
 */
export const PlatformSelector: React.FC = () => {
  const { platforms, currentPlatform, openSwitchModal } = useApplicationContext();

  // Nothing to select yet (still loading); avoid a blank trigger that opens an empty menu.
  if (platforms.length === 0) {
    return null;
  }

  return (
    <DropdownSelector
      ariaLabel="Open platform menu"
      selectedValue={currentPlatform}
      options={platforms}
      onSelect={(platform) => {
        if (platform !== currentPlatform) {
          openSwitchModal("platform", platform);
        }
      }}
      valueTestId="selected-platform"
    />
  );
};



